import { z } from 'zod/v4';

import { DrawRequestSchema, InterpretRequestSchema } from './schemas/api.schema';
import { LLMPayloadSchema } from './schemas/llm.schema';
import { MemoryEntitySchema } from './schemas/memory.schema';
import { ReadingSchema } from './schemas/reading.schema';
import { SpreadSchema } from './schemas/spreads.schema';
import { TarotCardSchema } from './schemas/tarot.schema';
import { WPSessionSchema } from './schemas/wp.schema';

export interface SchemaMetadata {
  entity: string;
  version: string;
  description: string;
  persistence?: 'browser' | 'server' | 'both' | 'none';
  exposure?: 'public' | 'private' | 'internal';
}

export const schemaRegistry = z.registry<SchemaMetadata>();

schemaRegistry.add(TarotCardSchema, {
  entity: 'TarotCard',
  version: '1.0.0',
  description: 'Canonical tarot card contract with hermetic, qabalistic and qliphotic metadata.',
  persistence: 'both',
  exposure: 'public',
});

schemaRegistry.add(SpreadSchema, {
  entity: 'Spread',
  version: '1.0.0',
  description: 'Spread contract with positional ritual coordinates and symbolic correspondences.',
  persistence: 'both',
  exposure: 'public',
});

schemaRegistry.add(ReadingSchema, {
  entity: 'Reading',
  version: '1.0.0',
  description: 'Persisted reading aggregate spanning draw, interpretation, audit and optional LLM text.',
  persistence: 'both',
  exposure: 'private',
});

schemaRegistry.add(MemoryEntitySchema, {
  entity: 'MemoryEntity',
  version: '1.0.0',
  description: 'User memory signal persisted for recurrence and Birkhoff analysis.',
  persistence: 'both',
  exposure: 'private',
});

schemaRegistry.add(WPSessionSchema, {
  entity: 'WPSession',
  version: '1.0.0',
  description: 'WordPress-native authenticated session contract.',
  persistence: 'none',
  exposure: 'private',
});

schemaRegistry.add(LLMPayloadSchema, {
  entity: 'LLMPayload',
  version: '1.0.0',
  description: 'Provider-agnostic LLM generation payload assembled by the orchestrator.',
  persistence: 'none',
  exposure: 'internal',
});

schemaRegistry.add(DrawRequestSchema, {
  entity: 'DrawRequestDTO',
  version: '1.0.0',
  description: 'REST DTO for tarot draw requests entering the WordPress plugin.',
  persistence: 'none',
  exposure: 'private',
});

schemaRegistry.add(InterpretRequestSchema, {
  entity: 'InterpretRequestDTO',
  version: '1.0.0',
  description: 'REST DTO for interpretation requests entering the WordPress plugin.',
  persistence: 'none',
  exposure: 'private',
});
